import { FC } from "react";
import systemLogo from "@/assets/images/system_logo.png";
import systemDefaultClose from "@/assets/images/system_default_close.png";
import systemHoverClose from "@/assets/images/system_hover_close.png";
import { useSystemHeader } from "./SystemHeader.hooks";

export const SystemHeader: FC = () => {
  const { onClickCloseSystem, user } = useSystemHeader();

  return (
    <div className="flex min-h-[51px] w-full flex-row bg-[#58697A]">
      <img className="h-[51px] w-[284px]" src={systemLogo} />

      <div className="absolute right-0 flex max-w-[calc(100%-220px)] flex-row items-center justify-end gap-x-5 p-2">
        {user && (
          <div className="flex h-[34px] flex-grow items-center justify-center truncate rounded bg-[#3B444E] px-3 text-white shadow-[0px_-1px_1px_0px_#FFFFFF47_inset]">
            <span className="text-sm text-white">{user.userName}</span>
          </div>
        )}
        <div className="flex min-w-[34px]">
          <button onClick={onClickCloseSystem} type="button" className="group">
            <img className="h-[32px] w-[34px] group-hover:hidden" src={systemDefaultClose} />
            <img className="hidden h-[32px] w-[34px] group-hover:block" src={systemHoverClose} />
          </button>
        </div>
      </div>
    </div>
  );
};
